import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "./aws-exports.js";

// const currentConfig = Auth.configure(awsconfig);

// Amplify.configure();

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(
  "CompanyName=Amopportunities, Inc.,LicensedApplication=AMO Development Platform,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036072,SupportServicesEnd=19_February_2024_[v2]_MTcwODMwMDgwMDAwMA==ad1959b9eb25420622119cec33d5d285"
);

if (environment.production) {
  enableProdMode();
}

// Used to properly register the SW
//https://stackoverflow.com/questions/50968902/angular-service-worker-swupdate-available-not-triggered

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // if ("serviceWorker" in navigator && environment.production) {
    //   navigator.serviceWorker.register("ngsw-worker.js");
    // }
    // console.log("SW registered");
  })
  .catch((err) => console.log(err));
